import { createAction, props } from "@ngrx/store";

export const setCompany = createAction("[Company Put Page] Set Company");

export const updateCompany = createAction("[Company Put Page] Update Company");
